<template>
  <div class="LoginContainer">
    <div class="LoginCard">
      <div class="Header">
        <div class="Title">Notemd.cloud</div>
        <div class="SubTitle">
          <span>已有账户？</span>
          <span class="Link" @click="GoToLogin">在此登录</span>
        </div>
      </div>

      <div class="Divider">
        <span>REGISTER</span>
      </div>

      <div class="Form">
        <!-- 邮箱 -->
        <div class="InputGroup">
          <label>邮箱</label>
          <input 
            v-model="register.data.email" 
            :disabled="register.state"
            class="Input" 
            ref="Email"
            data-name="Email" 
            placeholder="请输入邮箱"
            @keydown.enter="KeydownEnter"/>
        </div>

        <!-- 验证码 -->
        <div class="InputGroup">
          <label>验证码</label>
          <div class="CodeRow">
            <input 
              v-model="register.data.code" 
              :disabled="register.state"
              class="Input CodeInput" 
              ref="Code"
              data-name="Code" 
              placeholder="验证码"
              @keydown.enter="KeydownEnter"/>
            <button 
              class="SendCodeBtn" 
              :class="{ 'Disabled': countdown > 0 }"
              @click="SendCode" 
              :disabled="countdown > 0 || register.state">
              {{ countdown > 0 ? `${countdown}s 后重试` : '发送验证码' }}
            </button>
          </div>
        </div>

        <!-- 用户名 -->
        <div class="InputGroup">
          <label>用户名</label>
          <input 
            v-model="register.data.userName" 
            :disabled="register.state"
            class="Input" 
            ref="UserName"
            data-name="UserName" 
            placeholder="请输入用户名"
            @keydown.enter="KeydownEnter"/>
        </div>

        <!-- 密码 -->
        <div class="InputGroup">
          <label>密码</label>
          <input 
            v-model="register.data.password" 
            :disabled="register.state"
            class="Input" 
            ref="Password" 
            type="password"
            data-name="Password" 
            placeholder="请输入密码"
            @keydown.enter="KeydownEnter"/>
        </div>

        <!-- 确认密码 -->
        <div class="InputGroup">
          <label>确认密码</label>
          <input 
            v-model="register.data.confirmPassword" 
            :disabled="register.state"
            class="Input" 
            ref="ConfirmPassword" 
            type="password"
            data-name="ConfirmPassword" 
            placeholder="请再次输入密码"
            @keydown.enter="KeydownEnter"/>
        </div>

        <button 
          class="SubmitBtn" 
          :class="register.state ? 'Button_Disabled' : ''"
          @click="Register" 
          :disabled="register.state">
          <span>{{ register.state ? '注册中...' : '注 册' }}</span>
        </button>
      </div>
    </div>

    <Dialog v-if="control.dialog.state" :title="control.dialog.title"
      :acceptName="control.dialog.buttonName.accept"
      :cancelName="control.dialog.buttonName.cancel"
      :content="control.dialog.content"
      :icon="control.dialog.icon"
      :accept="control.dialog.accept"
      @dialogCancel="control.dialog.state = false">
    </Dialog>
  </div>
</template>

<script>
import Dialog from '../components/Dialog.vue'
export default {
  components: { Dialog },
  data () {
    return {
      control: {
        title: [],
        dialog: {
          state: false,
          title: '',
          content: '',
          icon: '/icon/warning.svg',
          buttonName: { accept: '好的', cancel: '' }
        }
      },
      register: {
        data: { email: '', code: '', userName: '', password: '', confirmPassword: '' },
        state: false
      },
      countdown: 0,
      timer: null
    }
  },
  methods: {
    GoToLogin() {
      this.$router.push('/Login')
    },
    KeydownEnter(event) {
      const inputName = event.currentTarget.dataset.name
      switch (inputName) {
        case 'Email': this.$refs.Code.focus(); break
        case 'Code': this.$refs.UserName.focus(); break
        case 'UserName': this.$refs.Password.focus(); break
        case 'Password': this.$refs.ConfirmPassword.focus(); break
        case 'ConfirmPassword': this.Register(); break
      }
    },
    ShowDialog(title, content) {
      this.control.dialog = {
        state: true,
        title: title,
        content: content,
        icon: '/icon/warning.svg',
        buttonName: { accept: '好的' },
        accept: () => { this.control.dialog.state = false }
      }
    },
    SendCode() {
      const email = this.register.data.email
      // 简单邮箱正则
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!email || !emailRegex.test(email)) {
        this.$Common.ShowToast(this, '请输入有效的邮箱地址', 'warning')
        return
      }

      this.$Common.ApiList(this, 'SendCode').then(url => {
        // 调用发送验证码接口
        // 设置 60s 超时，防止邮件发送慢导致前端超时
        this.axios.get(url, { params: { email }, timeout: 60000 }).then(res => {
          if (res.data.code === 200) {
            this.StartCountdown()
            this.$Common.ShowToast(this, '验证码已发送，请查收', 'success')
          } else {
            this.$Common.ShowToast(this, res.data.message || '验证码发送失败', 'warning')
          }
        }).catch((err) => {
          console.error('SendCode Error:', err)
          // 如果有响应信息，显示具体的错误
          if (err.response && err.response.data && err.response.data.message) {
            this.$Common.ShowToast(this, err.response.data.message, 'warning')
          } else if (err.message) {
             this.$Common.ShowToast(this, err.message, 'warning')
          } else {
            this.$Common.NetworkErrorDialog(this)
          }
        })
      })
    },
    StartCountdown() {
      this.countdown = 60
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    Register() {
      const { email, code, userName, password, confirmPassword } = this.register.data
      
      // 1. 基础校验
      if (!email) {
        this.ShowDialog('提示', '邮箱不能为空')
        return
      }
      if (!code) {
        this.ShowDialog('提示', '验证码不能为空')
        return
      }
      if (!userName) {
        this.ShowDialog('提示', '用户名不能为空')
        return
      }
      if (!password) {
        this.ShowDialog('提示', '密码不能为空')
        return
      }
      if (password !== confirmPassword) {
        this.ShowDialog('提示', '两次输入的密码不一致')
        return
      }

      this.register.state = true
      this.$Common.SetLoading('正在注册...')

      // 1. 验证验证码
      this.$Common.ApiList(this, 'VerifyCode').then(verifyUrl => {
        this.axios.get(verifyUrl, { params: { email, code } }).then(verifyRes => {
          if (verifyRes.data.code === 200) {
            // 2. 验证码正确，执行注册
            this.PerformRegister()
          } else {
            this.register.state = false
            this.$Common.RemoveLoading()
            this.ShowDialog('验证失败', verifyRes.data.message || '验证码错误')
          }
        }).catch(() => {
          this.register.state = false
          this.$Common.NetworkErrorDialog(this)
        })
      })
    },
    PerformRegister() {
      const { email, userName, password, code } = this.register.data
      this.$Common.ApiList(this, 'SignUp').then(url => {
        // Backend expects RegisterRequest: { userName, password, email, code }
        const payload = { userName, password, email, code }
        this.axios.post(url, payload).then(res => {
          this.register.state = false
          this.$Common.RemoveLoading()
          
          if (res.data.code === 200) {
             this.control.dialog = {
              state: true,
              title: '注册成功',
              content: '账号注册成功，请前往登录',
              icon: '/icon/success.svg',
              buttonName: { accept: '去登录' },
              accept: () => { 
                this.control.dialog.state = false
                this.$router.push('/Login') 
              }
            }
          } else {
            this.ShowDialog('注册失败', res.data.message || '注册失败，请稍后重试')
          }
        }).catch(() => {
          this.register.state = false
          this.$Common.NetworkErrorDialog(this)
        })
      })
    }
  },
  beforeUnmount() {
    if (this.timer) clearInterval(this.timer)
  },
  mounted () {
    this.$Common.SetLoading('正在加载组件, 请稍候...')
    this.$Common.SetDocTitle(this)
    this.$refs.Email.focus()
    this.$Common.RemoveLoading()
  }
}
</script>

<style scoped>
  .LoginContainer {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f2f5 url('/picture/LoginIndexBackGround.webp') no-repeat center center;
    background-size: cover;
  }

  .LoginCard {
    width: 400px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    padding: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .Header {
    text-align: center;
    margin-bottom: 20px;
    width: 100%;
  }

  .Title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-bottom: 8px;
  }

  .SubTitle {
    font-size: 14px;
    color: #666;
  }

  .Link {
    color: #409eff;
    cursor: pointer;
    margin-left: 5px;
    font-weight: 500;
  }

  .Link:hover {
    text-decoration: underline;
  }

  .Divider {
    width: 100%;
    text-align: center;
    border-bottom: 1px solid #eee;
    line-height: 0.1em;
    margin: 20px 0 30px;
  }

  .Divider span {
    background: #fff;
    padding: 0 10px;
    color: #999;
    font-size: 12px;
  }

  .Form {
    width: 100%;
  }

  .InputGroup {
    margin-bottom: 20px;
  }

  .InputGroup label {
    display: block;
    font-size: 12px;
    color: #333;
    margin-bottom: 8px;
    font-weight: bold;
  }

  .Input {
    width: 100%;
    height: 40px;
    border: 1px solid #dcdfe6;
    background: #f4f6f8;
    border-radius: 4px;
    padding: 0 15px;
    box-sizing: border-box;
    color: #333;
    font-size: 14px;
    transition: all 0.3s;
  }

  .Input:focus {
    border-color: #409eff;
    background: #fff;
  }
  
  .CodeRow {
    display: flex;
    gap: 10px;
  }
  
  .CodeInput {
    flex: 1;
  }
  
  .SendCodeBtn {
    width: 120px;
    height: 40px;
    background: #409eff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 13px;
    transition: background 0.3s;
  }
  
  .SendCodeBtn:hover {
    background: #66b1ff;
  }
  
  .SendCodeBtn.Disabled {
    background: #a0cfff;
    cursor: not-allowed;
  }

  .Controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    font-size: 14px;
    color: #666;
  }

  .SubmitBtn {
    width: 100%;
    height: 40px;
    background: #333;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    transition: background 0.3s;
    margin-top: 10px;
  }

  .SubmitBtn:hover {
    background: #000;
  }
  
  .Button_Disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
</style>